import * as React from "react";

import classnames from "classnames";
import { Chip } from "@dropbox/dig-components/chip";
import styles from "./LargeChip.module.css";

import type { ChipProps, ChipSize } from "@dropbox/dig-components/chip";

export type LargeChipSize = ChipSize | "large";

export type LargeChipProps = Omit<ChipProps, "size"> & {
  /**
   * The size of the chip.
   * Extends the base ChipSize to include 'large' as an option.
   */
  size?: LargeChipSize;

  /**
   * The following props are already defined within `ChipProps`.
   * Their behavior is exactly the same as within `Chip`.
   */
  /**
   * Optional callback when the chip is deleted
   */
  onDelete?: () => void;

  /**
   * Whether to show a dropdown icon
   */
  withDropdownIcon?: never;
};

export const LargeChip: React.FC<LargeChipProps> = ({
  size = "medium",
  ...props
}) => {
  /*
   * Chip does not support large implicitly. If `size` is `large`,
   * passes `medium` to `Chip` and apply overriding CSS styles.
   * Use `SelectableChip.LargeIconAccessory` for respective icons.
   */
  const chipSize: LargeChipSize = size === "large" ? "medium" : size;

  return (
    <Chip
      {...props}
      size={chipSize}
      className={classnames(styles.selectableChip, {
        [styles.large]: size === "large",
      })}
    />
  );
};
